module.exports = __webpack_public_path__ + "img/temp_pub_4.2.1a0b96d4.jpg";